import $ from 'jquery';
import 'slick';
import { 
    slickCommonOptions,
    globalConfig
} from './../../scripts/config';
import PerfectScrollbar from "perfect-scrollbar";
import {scrollSmooth} from "../../scripts/helpers";
/**
 * ProductGalleryV1 widget configs
 */
const productGalleryV1Semantics = {
    'mainWrapClass': 'product-gallery-v1',
    'bodyWrapClass': 'product-gallery-v1__body',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'commonPluginOptionsAttribute': 'data-common-plugin-options',
    'controlPrevClass': 'product-gallery-v1__prev',
    'controlNextClass': 'product-gallery-v1__next',
    'sliderWrapClass': 'product-gallery-v1__track',
    'sliderElementClass': 'product-gallery-v1__slider-element',
    'sliderElementWrapClass': 'product-gallery-v1__slider-element-wrap',
    'sliderElementNumberIndexAttribute': 'data-number-index',
    'sliderElementLoadStatusAttribute': 'data-is-loaded',
    'mainWrapSourceElementsUrlAttribute': 'data-source-elements-url',
    'mainWrapSourceListUrlAttribute': 'data-source-list-url',
    'mainWrapListIdAttribute': 'data-list-id',
    'mainWrapTotalCountAttribute': 'data-total-count',
    'categoryItemClass': 'product-gallery-v1__category-item',
    'categoryItemIdAttribute': 'data-id',
    'categoryLinkClass': 'product-gallery-v1__category-link',
    'headTitleSelector': '.product-gallery-v1__head .title-v2',
    'categoryActiveClass': '_active',
};

/**
 * ProductGalleryV1 initializer
 */
$(function() {
    ProductGalleryV1.init();
});

class ProductGalleryV1
{
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};

        // запоминаем что загруженно чтобы не делать повторные запросы
        this._requestedSlides = {};
    }

    static init() {
        if ($(`.${productGalleryV1Semantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.productGalleryV1) {
            window.widgets.productGalleryV1 = new ProductGalleryV1();
        }

        /**
         * Checking other instances
         */

        $(`.${productGalleryV1Semantics.mainWrapClass}`).each((index, el) => {
            let $el = $(el);
            let isInitialized =
                ($el.attr(`${productGalleryV1Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.productGalleryV1.registerInstance($el);
                window.widgets.productGalleryV1.registerScrollbarSync($el);
                window.widgets.productGalleryV1.registerArrowNavigation($el);
            }
        });

        ProductGalleryV1.reInitChildPlugins();

    }

    /**
     * TODO[justMvp]: внедрить универсальное решение
     * для переинициализации любых дочерних js-плагинов
     * внутри родительских
     * @return void
     */
    static reInitChildPlugins(
        timeout = 1000
    ) {
        setTimeout(() => {
            if (window.widgets.galleryV3) {
                window.widgets.galleryV3.resetInitialized(
                    $(`.${productGalleryV1Semantics.mainWrapClass}`)
                );
                window.widgets.galleryV3.initAll(
                    $(`.${productGalleryV1Semantics.mainWrapClass}`)
                );
            }
        }, timeout);
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let self = this;

        let instanceId = 
            el.attr(`${productGalleryV1Semantics.instanceIdAttribute}`) || false;
        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        let commonPluginOptions = 
            el.data(
                `${productGalleryV1Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};


        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: true,
                mobileFirst: true,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1420,
                        settings: {
                            centerPadding: '3rem',
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 1280,
                        settings: {
                            centerPadding: '2rem',
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 425,
                        settings: {
                            arrows: false,
                            centerPadding: '2rem',
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 0,
                        settings: {
                            arrows: false,
                            // centerPadding: '2rem',
                            slidesToShow: 1
                        }
                    }
                ],
                prevArrow: `.${productGalleryV1Semantics.mainWrapClass}` + 
                    `[${productGalleryV1Semantics.instanceIdAttribute}="` + 
                    el.attr(`${productGalleryV1Semantics.instanceIdAttribute}`) + 
                    `"] .${productGalleryV1Semantics.controlPrevClass}`,
                nextArrow: `.${productGalleryV1Semantics.mainWrapClass}` + 
                    `[${productGalleryV1Semantics.instanceIdAttribute}="` + 
                    el.attr(`${productGalleryV1Semantics.instanceIdAttribute}`) + 
                    `"] .${productGalleryV1Semantics.controlNextClass}`,
            }
        );
        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            // the better solution: impl pluginProvider
            // let slick = el.find(
            //     `.${productGalleryV1Semantics.sliderWrapClass}`
            // ).slick(pluginOptions);
            window.widgets.productGalleryV1.pluginInstances[instanceId] = self;

            el.attr(`${productGalleryV1Semantics.isInitializedAttribute}`, true);
            // добавление прослушивателей
            // для дозагрузки элементов
            self.registerListeners(el);

        } catch(e) {
            el.hide();
            throw e;
        }
    }

    reInit() {
        ProductGalleryV1.init();
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerListeners(el) {
        let self = this;

        let mainWrap = el.closest(
            `.${productGalleryV1Semantics.mainWrapClass}`
        );
        if (!mainWrap.length) {
            console.error(
                `ProductGalleryV1 виджет для элемента [el] ` + 
                `не может прослушивать нужные события, так как wrap-элемент ` + 
                `по селектору [selector] не был обнаружен!`, 
                {
                    el: el,
                    selector: `.${productGalleryV1Semantics.mainWrapClass}`
                }
            );
            return;
        }

        // Перед сменой слайдера (AJAX-дозагрузка элементов)
        // el.find(
        //     `.${productGalleryV1Semantics.sliderWrapClass}`
        // ).on('beforeChange',
        //
        // );

        // При смене товарной категории
        el.on('click', `.${productGalleryV1Semantics.categoryItemClass}`, function(e) {
            e.preventDefault();
            let status = $(this).hasClass(productGalleryV1Semantics.categoryActiveClass);
            if (status) {
                return;
            }

            // дозагрузка элементов
            $.ajax({
                url: mainWrap.attr(
                    `${productGalleryV1Semantics.mainWrapSourceListUrlAttribute}`
                ),
                method: 'GET',
                // processData: false,
                // contentType: false,
                cache: false,
                data: {
                    listId: mainWrap.attr(
                        `${productGalleryV1Semantics.mainWrapListIdAttribute}`
                    ),
                    categoryId: $(this).attr(productGalleryV1Semantics.categoryItemIdAttribute),
                    title: el.find(`${productGalleryV1Semantics.headTitleSelector}`).text(),
                },
                success: function (data) {
                    if (
                        typeof data !== 'object'
                            ||
                        (
                            typeof data === 'object'
                                &&
                            data['status'] !== true
                        )
                    ) {
                        console.error(
                            `При смене товарной категории в виджете ProductGalleryV1 ` + 
                            `элемента [el] ` +
                            `от сервера пришли невалидные данные! [responseData]`,
                            {
                                el: el,
                                responseData: data
                            }
                        );
                        return;
                    }

                    el.replaceWith(data['content']);
                    self.reInit();
                    ProductGalleryV1.reInitChildPlugins(100);
                },
                error: function(data) {
                    console.error(
                        `При смене товарной категории в виджете ProductGalleryV1 ` + 
                        `элемента [el] ` +
                        `сервер вернул ошибку! [responseData]`,
                        {
                            el: el,
                            responseData: data
                        }
                    );
                    return;
                }
            });
        })
 
        el.on('click', `.${productGalleryV1Semantics.categoryLinkClass}`, function(e) {
            e.preventDefault();
        })
    }

    registerScrollbarSync(el) {

        const track = el.find(`.${productGalleryV1Semantics.bodyWrapClass}`)[0];
        //const track = el[0];
        if (!track) return;

        // Инициализация PerfectScrollbar
        const ps = new PerfectScrollbar(track, {
            suppressScrollY: true,
            wheelPropagation: true,
        });

        // Принудительно обновляем после инициализации slick
        setTimeout(() => {
            ps.update();
        }, 100);

        // При ресайзе — обновить размеры
        window.addEventListener('resize', () => ps.update());

        // Автоматическое скрытие скроллбара, если он не нужен
        const maybeHideScrollbar = () => {
            if (track.scrollWidth <= track.clientWidth) {
                el.find('.ps__rail-x').hide();
            } else {
                el.find('.ps__rail-x').show();
            }
        };

        maybeHideScrollbar();
        let lastScrollTime = 0;
        track.addEventListener('scroll', () => {
            // вызывает обновление не чаще чем раз в 50мс.
            const now = Date.now();
            if (now - lastScrollTime < 50)
                return;
            lastScrollTime = now;

            maybeHideScrollbar();

            const scrollLeft = track.scrollLeft;
            const sliderTrack = el.find(`.${productGalleryV1Semantics.sliderWrapClass}`);
            const trackRightEdge = scrollLeft + track.clientWidth;
            const visibleElements = sliderTrack.find(`.${productGalleryV1Semantics.sliderElementWrapClass}`).filter(function() {
                const $el = $(this);
                const elLeft = $el.position().left + scrollLeft;
                const elRight = elLeft + $el.outerWidth(true);
                return elLeft < trackRightEdge && elRight > scrollLeft;
            });
            const lastVisible = visibleElements.last();
            const nextSlide = parseInt(
                lastVisible.find(`.${productGalleryV1Semantics.sliderElementClass}`).attr(
                productGalleryV1Semantics.sliderElementNumberIndexAttribute
            ));

            const instanceId = el.attr(productGalleryV1Semantics.instanceIdAttribute)
            const categoryId = el.find(
                `.${productGalleryV1Semantics.categoryItemClass}.${productGalleryV1Semantics.categoryActiveClass}`
            ).attr(productGalleryV1Semantics.categoryItemIdAttribute) || 0;
            const key = `${instanceId}:${categoryId}:${nextSlide}`;

            // не отправляем лишние одинаковые запросы.
            if (this._requestedSlides[key]) {
                return;
            }
            this._requestedSlides[key] = true;
            this.handleSlideLoadIfNeeded(el, nextSlide);
        });
    }

    registerArrowNavigation(el) {
        const track = el.find(`.${productGalleryV1Semantics.bodyWrapClass}`)[0];
        const prevBtn = el.find(`.${productGalleryV1Semantics.controlPrevClass}`);
        const nextBtn = el.find(`.${productGalleryV1Semantics.controlNextClass}`);
        const item = el.find(`.${productGalleryV1Semantics.sliderElementWrapClass}`).first();
        const rail = el.find('.ps__rail-x')[0];

        if (!track || !item.length) return;

        const itemWidth = item.outerWidth(true);

        const updateArrows = () => {
            const scrollLeft = track.scrollLeft;
            const scrollWidth = track.scrollWidth;
            const clientWidth = track.clientWidth;

            prevBtn.toggleClass('hidden', scrollLeft <= 0);
            nextBtn.toggleClass('hidden', scrollLeft + clientWidth >= scrollWidth - 1);
        };

        const updatePerfectScrollbar = (scrollLeft) => {
           rail.style.left = `${Math.round(scrollLeft)}px`;
        }
        // Клик влево
        prevBtn.on('click', (e) => {
            // perfectScrollBar конфликтует с behavior: 'smooth'
            // track.scrollBy({left: -itemWidth, behavior: 'smooth' });
            // поэтому придется городить свою плавную прокрутку.
            scrollSmooth(track, -itemWidth, 300, updateArrows, () => {
                updatePerfectScrollbar(track.scrollLeft);
            });
        });

        // Клик вправо
        nextBtn.on('click', (e) => {
            scrollSmooth(track, itemWidth, 300, updateArrows, updatePerfectScrollbar);
        });

        // позицию в 0 сбрасываю, чтобы браузер не запоминал положение скролла.
        track.scrollLeft = 0;
        // Обновление стрелок при скролле
        track.addEventListener('scroll', updateArrows);

        // Инициализируем
        updateArrows();
    }

    handleSlideLoadIfNeeded(el, nextSlide) {
        const mainWrap = el.closest(`.${productGalleryV1Semantics.mainWrapClass}`);
        const slickSlider = el.find(`.${productGalleryV1Semantics.sliderWrapClass}`);
        const slick = {
            $slider: [slickSlider[0]],
            $slides: slickSlider.find(`.${productGalleryV1Semantics.sliderElementWrapClass}`)
        };

        // исключаем другие под-слайдеры (например GalleryV3)
        if (slick.$slider[0].className.indexOf(
            productGalleryV1Semantics.sliderWrapClass
        ) === -1) {
            return;
        }
        // и исключаем слайды с кол-вом элементов менее четырех
        if (slick.$slides.length < 4) {
            return;
        }
        let nextSliderElement = $(slick.$slider[0]).find(
            `.${productGalleryV1Semantics.sliderElementClass}` +
            `[${
                productGalleryV1Semantics.sliderElementNumberIndexAttribute
            }` +
            `=
            "${nextSlide}"
            ]`
        );

        if (!nextSliderElement.length) {
            console.error(
                `ProductGalleryV1 виджет для элемента [el] ` +
                `не может загружать другие элементы, так как ` +
                `по селектору [selector] не был обнаружен!`,
                {
                    el: el,
                    selector: (
                        `.${productGalleryV1Semantics.sliderElementClass}` +
                        `[${
                            productGalleryV1Semantics.sliderElementNumberIndexAttribute
                        }` +
                        `="${nextSlide}"]`
                    )
                }
            );
            return;
        }
        let nextSliderWrapElement = (nextSliderElement.hasClass(
            productGalleryV1Semantics.sliderElementWrapClass
        ))
            // когда nextSliderWrapElement является nextSliderElement
            ? nextSliderElement
            // для случаев когда slick-плагин добавляет собственную обертку
            : nextSliderElement.closest(
                `.${productGalleryV1Semantics.sliderElementWrapClass}`
            );

        let offset = nextSlide;
        let limit = 4;
        let totalCount = parseInt(mainWrap.attr(
            `${productGalleryV1Semantics.mainWrapTotalCountAttribute}`
        ));
        let maxNumberIndex = (totalCount - 1);

        // offset всегда по индексу следующего элемента (nextSlide),
        // а limit по умолчанию всегда 4
        // (не больше 4 элементов в слайдере за раз для desktop-версий)

        // далее алгоритм может изменить offset или limit по
        // следующим кейсам:
        // 1) Все 4 анализируемых элемента (первый по nextSlide и следующие 3 после него)
        // имеют статус "Загружены" (limit и offset устанавливаются в 0, ничего не загружается)
        // 2) Все 4 анализируемых элемента
        // имеют статус "Не загружено" (limit и offset остаются не тронутыми, загрузка в штатном режиме)
        // 3) n элементов (где n>0) имеют статус "Загружено" С ПЕРВОГО элемента
        // (offset смещается на n элементов влево (offset - n), с проверкой на диапазон [0;maxNumberIndex])
        // 4) n элементов (где n>0) имеют статус "Загружено" НЕ С ПЕРВОГО элемента
        // (limit уменьшается на n (limit - n), с проверкой на диапазон [0;n])

        // true = Загружено / false = Не загружено
        let elementLoadStatuses = [];

        // первый элемент
        if (nextSliderElement.attr(
            `${productGalleryV1Semantics.sliderElementLoadStatusAttribute}`
        ) == 0) {
            elementLoadStatuses.push(false);
        } else if (
            nextSliderElement.attr(
                `${productGalleryV1Semantics.sliderElementLoadStatusAttribute}`
            ) == 1
        ) {
            elementLoadStatuses.push(true);
        }
        let beforeElement = nextSliderWrapElement;

        // следующие 3 элемента
        for (let i = 1; i <= 3; i++) {
            let wrapElement = beforeElement.next(
                `.${productGalleryV1Semantics.sliderElementWrapClass}`
            );
            let element = (wrapElement.hasClass(
                productGalleryV1Semantics.sliderElementClass
            ))
                // когда sliderElementClass это тот же элемент что и sliderElementWrapClass
                ? wrapElement
                // для случая когда slick-плагин добавляет собственную обертку
                : wrapElement.find(
                    `.${productGalleryV1Semantics.sliderElementClass}`
                );
            if (wrapElement.length) {
                if (
                    element.attr(
                        `${productGalleryV1Semantics.sliderElementLoadStatusAttribute}`
                    ) == 0
                ) {
                    elementLoadStatuses.push(false);
                } else if (
                    element.attr(
                        `${productGalleryV1Semantics.sliderElementLoadStatusAttribute}`
                    ) == 1
                ) {
                    elementLoadStatuses.push(true);
                }
            }
            beforeElement = wrapElement;
        }

        if (elementLoadStatuses.length < 1) {
            console.error(
                `ProductGalleryV1 виджет для элемента [el] ` +
                `не может загрузить дополнительные элементы так как получил ` +
                `неверный набор значений [elementLoadStatuses]`,
                {
                    el: el,
                    elementLoadStatuses: elementLoadStatuses,
                }
            );
            return;
        }

        // далее алгоритм может изменить offset или limit по
        // следующим кейсам:

        // 1) Все 4 анализируемых элемента (первый по nextSlide и следующие 3 после него)
        // имеют статус "Загружены" (limit и offset устанавливаются в 0, ничего не загружается)

        // 2) Все 4 анализируемых элемента
        // имеют статус "Не загружено" (limit и offset остаются не тронутыми, загрузка в штатном режиме)

        // 3) n элементов (где n>0) имеют статус "Загружено" С ПЕРВОГО элемента
        // (offset смещается на n элементов вправо (offset + n),
        // с проверкой на диапазон [0;maxNumberIndex], limit уменьшается на n (limit - n),
        // с проверкой на диапазон [0;4])

        // 4) n элементов (где n>0) имеют статус "Загружено" НЕ С ПЕРВОГО элемента
        // (limit уменьшается на n (limit - n), с проверкой на диапазон [0;4],
        // offset не изменяется (движение слайдера вправо))

        if (!elementLoadStatuses.includes(false)) {
            // все 4 элемента имеют статус "Загружены"
            limit = 0;
            offset = 0;
        } else if (!elementLoadStatuses.includes(true)) {
            // все 4 элемента имеют статус "Не загружено"
        } else if (elementLoadStatuses[0]) {
            // n элементов (где n>0) имеют статус "Загружено" С ПЕРВОГО элемента
            offset += elementLoadStatuses.filter((element) => element).length;
            limit -= elementLoadStatuses.filter((element) => element).length;
            if (offset > maxNumberIndex) {
                offset = maxNumberIndex;
            }
        } else if (!elementLoadStatuses[0] && elementLoadStatuses.includes(true)) {
            // n элементов (где n>0) имеют статус "Загружено" НЕ С ПЕРВОГО элемента
            limit -= elementLoadStatuses.filter((element) => element).length;
        }

        if (limit <= 0) {
            if (globalConfig.isDebugMode === true) {
                console.info(
                    `ProductGalleryV1 виджет для элемента [el] ` +
                    `не требует дополнительной загрузки, исходя из элементов ` +
                    `[limit] и [offset]`,
                    {
                        el: el,
                        limit: limit,
                        offset: offset,
                    }
                );
            }
            return;
        }

        // дозагрузка элементов
        $.ajax({
            url: mainWrap.attr(
                `${productGalleryV1Semantics.mainWrapSourceElementsUrlAttribute}`
            ),
            method: 'GET',
            // processData: false,
            // contentType: false,
            cache: false,
            data: {
                listId: mainWrap.attr(
                    `${productGalleryV1Semantics.mainWrapListIdAttribute}`
                ),
                limit: limit,
                offset: offset
            },
            success: function (data) {
                if (typeof data !== 'object') {
                    console.error(
                        `При дозагрузки элементов в виджете ProductGalleryV1 ` +
                        `элемента [el] ` +
                        `от сервера пришли невалидные данные! [responseData]`,
                        {
                            el: el,
                            responseData: data
                        }
                    );
                    return;
                }
                for (var elementNumberIndex in data) {
                    // заменяем элемент заглушку на html-контент
                    // дозагруженного элемента
                    $(slick.$slider[0]).find(
                        `.${productGalleryV1Semantics.sliderElementClass}` +
                        `[${
                            productGalleryV1Semantics.sliderElementNumberIndexAttribute
                        }` +
                        `=
                        "${elementNumberIndex}"
                        ]`
                    ).replaceWith(data[elementNumberIndex]);

                    // перезапускаем инициализацию дочерних плагинов
                    // (например GalleryV3)
                    ProductGalleryV1.reInitChildPlugins(100);

                }
            },
            error: function (data) {
                console.error(
                    `При дозагрузки элементов в виджете ProductGalleryV1 ` +
                    `элемента [el] ` +
                    `сервер вернул ошибку! [responseData]`,
                    {
                        el: el,
                        responseData: data
                    }
                );
                return;
            }
        });
    }
}